import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'product_gallery',
    initialState: {
        products: [],
        categories: [],
    },
    reducers: {
        getProducts: (state, action) => {
            state.products = action.payload
        },
        getCategories: (state, action) => {
            state.categories = action.payload
        },
    }
})

// Barcha mahsulot rasmlarini olish (kategoriya bo'yicha filter bilan)
export const getAllProducts = (categoryId = '') => apiCall({
    url: categoryId ? `product-gallery/?category=${categoryId}` : 'product-gallery/',
    method: 'GET',
    onSuccess: slice.actions.getProducts.type
})

// Barcha kategoriyalarni olish
export const getProductCategories = () => apiCall({
    url: 'product-categories/',
    method: 'GET',
    onSuccess: slice.actions.getCategories.type
})

export default slice.reducer
